// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Udik","selected":"Chip_selected__yN8vj"};